<div class="wrap">

    <h3>{{this.data.camera.name}}</h3>
    <p>Actions:</p>

    <div class="action">
        <div class="demo">
            <span>Demo</span>
            <mat-slide-toggle [color]="color" [checked]="true">Prod</mat-slide-toggle>
        </div>

        <div class="reset">
            <button [color]="color" mat-raised-button matTooltip="Restart camera">
                Reset
            </button>
        </div>



    </div>
    <p>battery alert
    </p>
    <div class="mail">

        <div class="pourcent">
            <form>
                <mat-form-field class="tailleTexte" appearance="fill">
                    <mat-label>Niveau d'alerte</mat-label>

                    <input class="champ" type="text" matInput>
                    <span matSuffix>% &nbsp;</span>

                </mat-form-field>
            </form>
        </div>
        <form class="email">
            <mat-form-field class="example-full-width" appearance="fill">
                <mat-label>Email de contact</mat-label>
                <input type="email" matInput placeholder="Ex. pat@example.com">
                <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
                    Veuillez entrer une adresse mail valide
                </mat-error>
                <mat-error *ngIf="emailFormControl.hasError('required')">
                    Email requis
                </mat-error>
            </mat-form-field>
        </form>
    </div>


    <hr>

    <div class="close">
        <button type="button" [color]="color" mat-raised-button (click)="dialogRef.close()">Fermer</button>
    </div>
</div>